module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"National Assembly of Belize: Documents","short_name":"BNA Docs","start_url":"/","background_color":"#eaeeee","theme_color":"#1d5356","display":"minimal-ui","icon":"src/images/bna-favicon-520x520.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"45bbaf7e62e4b89375247a29b69f98a9"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
